import Component from '@glimmer/component';
import { service } from '@ember/service';
import Settings from 'donor-elf-web/services/settings';

interface ComponentArgs {
  changeset: any;
  type: 'phone' | 'email';
}

export default class AddSomethingModalContactPhoneOrEmailComponent extends Component<ComponentArgs> {
  @service declare settings: Settings;

  get showSyncToMailchimp() {
    return (
      this.args.type === 'email' && this.settings.mailchimpFundSyncSlim != null
    );
  }
}
